var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.136,
    height: 19.531,
    viewBox: "0 0 18.136 19.531",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_149665",
    "data-name": "Group 149665",
    transform: "translate(-3.003 -2.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102381",
    "data-name": "Path 102381",
    d: "M7.188,2.013A2.1,2.1,0,0,0,5.1,4.106V6.2H3.7a.7.7,0,0,0,0,1.4H5.1v3.488H3.7a.7.7,0,0,0,0,1.4H5.1v3.488H3.7a.7.7,0,1,0,0,1.4H5.1v2.093a2.1,2.1,0,0,0,2.093,2.093H19.046a2.1,2.1,0,0,0,2.093-2.093V4.106a2.1,2.1,0,0,0-2.093-2.093ZM12.768,5.5a2.79,2.79,0,1,1-2.79,2.79A2.8,2.8,0,0,1,12.768,5.5Zm-1.4,6.278h2.79a2.79,2.79,0,1,1,0,5.58h-2.79a2.79,2.79,0,1,1,0-5.58Z",
    fill: "#014cec",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressIcon);
export default __webpack_public_path__ + "static/media/AddressIcon.8bbd363c81bef52d1fc4eeb8edb0bb4a.svg";
export { ForwardRef as ReactComponent };